import {Controller} from "@hotwired/stimulus"
import Cookies from "js-cookie"

export class NavSectionController extends Controller {
    static values = {cookie: String}

    toggle() {
        const open = this.element.classList.toggle("show")
        this.element.setAttribute("aria-expanded", open)
        Cookies.set(this.cookieValue, open)
    }
}
